export default __webpack_public_path__ + "static/media/panels-min.f4b379ce.png";